(ns manage.content-variant-page.content-configuration.db
  (:require [clojure.string :as str]
            [common.datascript.schema :as ds]
            [datascript.core :as d]))

(defn replace-invalid-chars [name]
  (str/replace name #"[^-_A-Za-z0-9]" "_"))

(defn relink-placeholder-expressions
  "finds all default placeholder expressions that also occur as placeholder
  override (with same value), then deletes the default and sets the override as
  the new default"
  [imported-cfn-tx-data]
  (let [db (-> (d/empty-db ds/schema)
               (d/db-with imported-cfn-tx-data))]
    (->> (d/q '[:find ?phe ?p ?o :in $ :where
                [?p :placeholder/default-value ?phe]
                [?phe :singular-placeholder-expression/strings ?ds]
                [?p :placeholder/override ?o]
                [?o :singular-placeholder-expression/strings ?os]
                [(= ?ds ?os)]] db)
         (reduce (fn [res [default-phe placeholder override-phe]]
                   (conj res
                         [:db/add placeholder :placeholder/default-value override-phe]
                         [:db/retractEntity default-phe]))
                 [])
         (d/db-with db))))
